import request from "../../../../utils/api";

export const getMarketingPartners = params => {
  return request("v1/sellers/marketing-partner", {
    params
  });
};
export const searchMarket = params => {
  return request("v1/sellers/marketingpartner/search-marketing/", {
    method: "post",
    params
  });
};
export const saveReason = params => {
  return request(`v1/cms/marketing-partner/appeal/${params.id}`, {
    method: "post",
    params
  });
};
export const postMarketingPartners = params => {
  return request(`v1/sellers/marketing-partner/${params.id}`, {
    method: "post",
    body: params
  });
};

export const getMaintainedValues = params => {
  return request("v1/mv", {
    params
  });
};
